import { render, staticRenderFns } from "./doCopyWork.vue?vue&type=template&id=10f5d5e2&scoped=true"
import script from "./doCopyWork.vue?vue&type=script&lang=js"
export * from "./doCopyWork.vue?vue&type=script&lang=js"
import style0 from "./doCopyWork.vue?vue&type=style&index=0&id=10f5d5e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f5d5e2",
  null
  
)

export default component.exports